<template>
  <div v-if="visible" class="support-fab-wrap">
    <transition name="fab-menu">
      <div v-if="menuAbierto" class="fab-menu" @click.self="menuAbierto = false">
        <button class="fab-menu__item" @click="elegir('ver-tickets')">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M4 6h16M4 12h16M4 18h10" stroke="#01662E" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <span>Mis tickets</span>
        </button>
        <button class="fab-menu__item" @click="elegir('click')">
          <svg width="18" height="18" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M10 28v-4a14 14 0 0 1 28 0v4" stroke="#01662E" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10 28h4a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-8z" fill="#01662E"/>
            <path d="M38 28h-4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-8z" fill="#01662E"/>
            <path d="M32 38a4 4 0 0 1-4 4h-4" stroke="#01662E" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span>Abrir ticket</span>
        </button>
      </div>
    </transition>

    <button
      class="support-fab"
      :class="{ 'support-fab--activo': menuAbierto }"
      title="Soporte"
      @click="menuAbierto = !menuAbierto"
    >
      <svg class="support-fab__icon" width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M10 28v-4a14 14 0 0 1 28 0v4" stroke="#01662E" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10 28h4a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-8z" fill="#01662E"/>
        <path d="M38 28h-4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-8z" fill="#01662E"/>
        <path d="M32 38a4 4 0 0 1-4 4h-4" stroke="#01662E" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span class="support-fab__label">Soporte</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'SupportFab',
  data() {
    return {
      menuAbierto: false,
    };
  },
  computed: {
    isLogged() {
      return !!this.$store.getters.isLogged;
    },
    cateringId() {
      return this.$store.getters.getCateringId;
    },
    visible() {
      // getCateringId (no getKitchenId, que es especifico de Foodcourt/dark
      // kitchens) - el boton de tickets debe verse para cualquier lead, sea
      // Menu Diario, On Demand o Franchises.
      return this.isLogged && this.cateringId != null;
    },
  },
  methods: {
    elegir(evento) {
      this.menuAbierto = false;
      this.$emit(evento);
    },
  },
};
</script>

<style scoped>
.support-fab-wrap {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1040;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
}

.fab-menu {
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: #ffffff;
  border-radius: 14px;
  padding: 6px;
  box-shadow:
    0 10px 30px -8px rgba(1, 102, 46, 0.22),
    0 4px 10px -2px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(1, 102, 46, 0.08);
}

.fab-menu__item {
  display: flex;
  align-items: center;
  gap: 10px;
  background: none;
  border: none;
  padding: 10px 14px;
  border-radius: 10px;
  cursor: pointer;
  font-family: inherit;
  font-size: 13.5px;
  font-weight: 600;
  color: #1f2937;
  white-space: nowrap;
  transition: background 0.15s ease;
}
.fab-menu__item:hover {
  background: #f4faf6;
}

.support-fab {
  width: 76px;
  height: 76px;
  border-radius: 18px;
  background: #ffffff;
  border: 1px solid rgba(1, 102, 46, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  cursor: pointer;
  box-shadow:
    0 10px 30px -8px rgba(1, 102, 46, 0.22),
    0 4px 10px -2px rgba(0, 0, 0, 0.06);
  transition: transform 0.18s cubic-bezier(.2, .8, .2, 1),
              box-shadow 0.25s ease,
              border-color 0.2s ease;
  padding: 0;
}

.support-fab:hover,
.support-fab--activo {
  transform: translateY(-3px);
  border-color: rgba(1, 102, 46, 0.25);
  box-shadow:
    0 16px 36px -8px rgba(1, 102, 46, 0.32),
    0 8px 18px -4px rgba(0, 0, 0, 0.08);
}

.support-fab:active {
  transform: translateY(-1px) scale(0.97);
}

.support-fab__icon {
  display: block;
}

.support-fab__label {
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  color: #01662E;
  letter-spacing: 0.3px;
}

.fab-menu-enter-active, .fab-menu-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}
.fab-menu-enter, .fab-menu-leave-to {
  opacity: 0;
  transform: translateY(6px);
}
</style>
